'use client';

import { FC, useEffect, useRef } from 'react';
import styles from './help-center-chat-widget.module.scss';
import { CatPopover } from '@blocks-react/components/Popover';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconMessageMultiple } from '@blocks-react/components/Icons/MessageMultiple';
import { HelpCenterChatWidgetProps } from './types';
import { useActiveControl } from '../../hooks';

const DELAY_MINUTES_TO_SHOW_DEFAULT = 3;

export const HelpCenterChatWidget: FC<HelpCenterChatWidgetProps> = ({
  title,
  buttonText,
  linkToHelpChat,
  delayMinutesToDisplay
}) => {
  const { close, open, isActive } = useActiveControl();
  const timeOutId = useRef<number | null>(null);
  const timeoutValue =
    (delayMinutesToDisplay
      ? +delayMinutesToDisplay
      : DELAY_MINUTES_TO_SHOW_DEFAULT) *
    1000 *
    60;

  useEffect(() => {
    const preventShowProactiveChat = () => {
      if (timeOutId.current !== null) {
        clearTimeout(timeOutId.current);
        timeOutId.current = null;
      }
    };

    if (timeOutId.current === null) {
      timeOutId.current = window.setTimeout(open, timeoutValue);
    }

    document.addEventListener('click', preventShowProactiveChat);

    return () => {
      document.removeEventListener('click', preventShowProactiveChat);
    };
  }, [open, timeoutValue]);

  return (
    <CatPopover
      isActive={isActive}
      className={styles['help-center-chat-widget--container']}
      position="bottom-end"
      heading={title}
      headingVariant="title"
      headingTagName="h3"
      onBlPopoverClose={close}
      onMouseLeave={close}
    >
      <CatButton
        onMouseEnter={open}
        slot="trigger"
        data-testid="chatWidgetButton"
        href={linkToHelpChat}
        target="_blank"
        aria-expanded
      >
        <div className="py-1">
          <CatIconMessageMultiple size="lg" />
        </div>
      </CatButton>
      <CatButton
        variant="primary"
        href={linkToHelpChat}
        target="_blank"
        fullWidth
      >
        {buttonText}
      </CatButton>
    </CatPopover>
  );
};
